var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"aria-hidden":"true","title":"Facebook Icon","aria-label":"Facebook Icon","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 32"}},[_c('path',{attrs:{"d":"M18,6h-4c-0.6,0-2,0.9-2,2v4h6v6h-6v14H6V18H0v-6h6V8c0-4.4,3.9-8,8.1-8H18V6z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92d3baac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IconFacebook.vue
// module id = null
// module chunks = 